import React, { useEffect, useMemo, useState } from "react";
import PhoneInput, { isPossiblePhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SecondLayout from "../layouts/SecondLayout";
import { Variables } from "../variables";

const Order = () => {
  const { name, category } = useMemo(() => {
    const p = new URLSearchParams(window.location.search);
    return {
      name: (p.get("name") || p.get("Name") || "").trim(),
      category: (p.get("category") || p.get("Category") || "").trim(),
    };
  }, []);

  const defaultMsg = useMemo(() => {
    const n = name || "";
    const c = category || "";
    return `I am interested to buy ${n} - ${c}`;
  }, [name, category]);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [additionalNotes, setAdditionalNotes] = useState("");
  const [location, setLocation] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState(defaultMsg);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => setMessage(defaultMsg), [defaultMsg]);

  const onSubmit = async (e) => {
    e.preventDefault();

     if (!firstName.trim()) {
      toast.error("First Name cannot be empty.");
      return;
    }
     if (!lastName.trim()) {
      toast.error("Last Name cannot be empty.");
      return;
    }
    if (!email.trim()) {
      toast.error("Please enter your email.");
      return;
    }
    if (!phone || !isPossiblePhoneNumber(phone)) {
      toast.error("Please enter a valid phone number.");
      return;
    }
        if (!location.trim()) {
      toast.error("location cannot be empty.");
      return;
    }
    if (!message.trim()) {
      toast.error("Message cannot be empty.");
      return;
    }

    setSubmitting(true);
    try {
      let isMounted = true;
      const controller = new AbortController();

      const fetchData = async () => {
        try {
          setSubmitting(true);

          const url = Variables.API_URL + "Rasha/Contact/Upsert";

          const response = await fetch(url, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              firstName: firstName,
              lastName: lastName,
              email: email,
              phoneNumber: phone,
              location: location,
              additionalNotes: additionalNotes,
              body: message,
            }),
            signal: controller.signal,
          });

          const result = await response.json();

          if (!response.ok) {
            throw new Error(result?.message || "Failed to fetch content");
          }

          if (isMounted){
            toast.success(result)
            setFirstName("")
            setLastName("")
            setAdditionalNotes("")
            setEmail("")
            setPhone(undefined)
            setLocation("")
          }
        } catch (err) {
          if (isMounted && err.name !== "AbortError") {
            console.log(err.message || "Something went wrong")
          }
        } finally {
          if (isMounted) setSubmitting(false);
        }
      };

      fetchData();

      return () => {
        isMounted = false;
        controller.abort();
      };
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <SecondLayout>
      <main className="order-page">
        <h1 className="page-title">Order Inquiry</h1>

        <section className="order-grid">
          {/* Left: form */}
          <form className="card form-card" onSubmit={onSubmit}>
            <div className="d-flex">
              <label className="field mr-20">
              <span className="label">
               First Name <span className="req">*</span>
              </span>
              <input
                type="text"
                placeholder="John"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                className="input"
              />
            </label>
            <label className="field">
              <span className="label">
                Last Name <span className="req">*</span>
              </span>
              <input
                type="text"
                placeholder="Doe"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                className="input"
              />
            </label>
            </div>
            <label className="field">
              <span className="label">
                Your Email <span className="req">*</span>
              </span>
              <input
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input"
              />
            </label>

            <label className="field">
              <span className="label">
                Your Phone Number <span className="req">*</span>
              </span>
              <PhoneInput
                international
                placeholder="+123 456 7890"
                value={phone}
                onChange={setPhone}
                className="input"
              />
            </label>
            <label className="field">
              <span className="label">
                Address <span className="req">*</span>
              </span>
              <input
                type="text"
                placeholder="Your Address"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                className="input"
              />
            </label>
            <label className="field">
              <span className="label">
                Additional Notes
              </span>
              <input
                type="text"
                placeholder="additional Notes"
                value={additionalNotes}
                onChange={(e) => setAdditionalNotes(e.target.value)}
                className="input"
              />
            </label>

            <label className="field">
              <span className="label">Message</span>
              <textarea
                className="textarea"
                rows={8}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </label>

            <button className="btn-primary" disabled={submitting}>
              {submitting ? "SENDING..." : "SEND"}
            </button>
          </form>

          {/* Right: contact info */}
          <aside className="card contact-card">
            <h2 className="contact-title">Contact Info</h2>

            <div className="contact-block">
              <div className="contact-heading">Email Us</div>
              <a href="mailto:order@rashaabanni.com" className="contact-link">
                order@rashaabanni.com
              </a>
            </div>

            <div className="contact-block">
              <div className="contact-heading">Call Us</div>
              <div className="contact-text">
                <a href="tel:+447470241182">+44 7470 241182</a>
              </div>
            </div>
          </aside>
        </section>
      </main>
      <ToastContainer />
    </SecondLayout>
  );
};

export default Order;
